module.exports = __webpack_public_path__ + "static/img/introduce_10.0530d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_10.png
// module id = /w9A
// module chunks = 1